// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"619":"5963f375","937":"b2602235"}[chunkId] + ".chunk.css";
};